module.exports = __webpack_public_path__ + "static/left-card-daf0881ab4b645968fc886c82264001b.png";